import { type PropsWithChildren, forwardRef } from "react";

import type { BaseTextAreaProps } from "./BaseTextArea.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const BaseTextArea = forwardRef<
  HTMLTextAreaElement,
  PropsWithChildren<BaseTextAreaProps>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "h-full min-h-20 w-full resize-none rounded-md border border-neutral-500 text-sm text-neutral-900",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});

BaseTextArea.displayName = "BaseTextArea";

export default BaseTextArea;
